import React, { useEffect, useRef, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import { Link } from "react-router-dom";

const steps = [
  { id: 1, first:"Contact Us", title: "Today", description: "Give us a call or fill out our online form to get started. We have a team of experienced real estate professionals ready to help." },
  { id: 2, first:"Schedule", title: "a Meeting", description: "We will schedule a short meeting to learn about your specific requirements for your real estate investing." },
  { id: 3, first:"Discuss", title: "Your Goals", description: "During the meeting, you can share your investment goals. We will gather information from you so that we can match you to personalized opportunities." },
  { id: 4, first:"Choose", title: "Your Property", description: "After your meeting, we will send you curated deals that match your investment criteria. Then, choose the property that makes the most sense for you." },
  { id: 5, first:"Close", title: "and Repeat", description: "We help close your deal efficiently and prepare you for the next one." },
];

export default function OurProcess() {

  const [currentStep, setCurrentStep] = useState(-1);
  const videoRef = useRef(null);
  const refs = useRef([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.75; // Set video speed
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.getAttribute("data-index"));
          if (entry.isIntersecting) {
            setCurrentStep(index);
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    refs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      refs.current.forEach((el) => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  const variants = {
    hidden: (direction) => ({
      opacity: 0,
      x: direction === "left" ? -100 : 100,
    }),
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 1.3 },
    },
  };
  // useEffect(() => {
  //   window.scrollTo(0, 0);

  // }, []);
  return (<div>
    <div className="relative w-full h-auto md:h-screen overflow-hidden flex flex-col md:block">
      
    <div className="relative w-full h-[60vh] md:h-full">
      <video
        ref={videoRef}
        className="w-full h-full object-cover"
        src="/assets/videos/our-process-hero.mp4"
        autoPlay
        loop
        muted
        playsInline
      />
      {/* Dark Overlay only on desktop */}
      <div className="hidden md:block absolute inset-0 bg-black/30"></div>
    </div>

      {/* Animated Left Section */}
      <motion.div
        initial={{ x: "-100%" }}
        animate={{ x: 0 }}
        transition={{ 
          type: "spring", 
          stiffness: 60, 
          damping: 20,
          delay: 0.5
        }}
        className="bg-slate-800 backdrop-blur-md p-8 md:w-1/3 w-full flex items-center justify-center md:absolute md:top-0 md:left-0 md:h-full z-20"
      >
        <div className="p-6 md:p-10 space-y-8 text-left md:text-left">
          <h2 className="md:text-4xl text-3xl font-semibold text-white leading-tight">
            Our <span className="text-teal-500">Process</span>
          </h2>
          <p className="text-white text-lg md:text-xl leading-relaxed">
            We believe in a streamlined and efficient process that ensures quality results every time. From planning to execution, we handle everything with utmost precision and care.
          </p>
      
        </div>
      </motion.div>

    </div>


{/* Progress bar here ....... */}
 
<section className="relative w-full bg-slate-950 py-20" 


>
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row gap-10">
          {/* Step Content */}
          <div className="relative flex-1">
            {steps.map((step, index) => (
              <div
                key={step.id}
                ref={(el) => (refs.current[index] = el)}
                data-index={index}
                className="min-h-screen flex items-center w-full overflow-x-hidden"
              >
               <motion.div
  className={`w-full max-w-full md:w-1/2 px-4 py-6 rounded-lg shadow-lg shadow-teal-500 bg-gray-50 ${
    index % 2 === 0 ? "md:mr-auto" : "md:ml-auto"
  }`}
  custom={index % 2 === 0 ? "left" : "right"}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: false, amount: 0.5 }}
  variants={variants}
>
  <h2 className="text-2xl md:text-3xl font-bold mb-2 text-slate-900">
    {index + 1}. <span className="text-teal-500">{step.first}</span> {step.title}
  </h2>
  <p className="text-gray-600 text-base md:text-lg">{step.description}</p>
</motion.div>

              </div>
            ))}
          </div>

          {/* Progress Bar */}
          <div className="hidden md:flex flex-col items-center sticky top-1/4 h-[250px] w-10">
            {steps.map((_, idx) => (
              <div key={idx} className="flex flex-col items-center">
                <div
                  className={`w-5 h-5 rounded-full border-2 transition-all duration-1000 ${
                    idx <= currentStep ? "bg-teal-500 border-teal-500" : "bg-slate-200 border-slate-200"
                  }`}
                />
                {idx < steps.length - 1 && <div className={`w-1 h-12 transition-all duration-3000 ${
                  idx < currentStep ? "bg-teal-500" : "bg-slate-200"
                }`} />}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>





   <div className="relative w-full h-full overflow-hidden">
  {/* Background Video */}
  <video
    autoPlay
    loop
    muted
    playsInline
    className="absolute top-0 left-0 w-full h-full object-cover z-0"
  >
    <source src="/assets/videos/investor-rise-bg-map.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>

  {/* Overlay for darkening the background */}
 <div className="absolute inset-0 bg-black bg-opacity-30" />

  {/* Main Content */}
  <div className="relative z-20">
    <div className="flex flex-col md:flex-row-reverse items-center justify-between px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10">
      {/* Text Section with Animated Reveal */}
      <div className="md:w-1/2 relative">
        <div className="overflow-hidden">
          <motion.div
            initial={{ clipPath: 'inset(0 100% 0 0)' }}
            whileInView={{ clipPath: 'inset(0 0% 0 0)' }}
            transition={{ duration: 1.2, ease: "easeInOut", delay: 1 }}
            viewport={{ once: true }}
            className="bg-white/90 p-8 rounded-lg shadow-lg"
          >
            <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-slate-900">Contact Us</h2>
            <p className="text-black text-base sm:text-lg leading-relaxed">
              Give us a call or fill out our online form to get started. We have a team of experienced real estate professionals ready to help.
            </p>
            <Link to="/contact">
              <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold bg-teal-500 shadow-xl text-lg group">
                <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-tslate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
                <span className="relative z-10">Contact Us</span>
              </button>
            </Link>
          </motion.div>
        </div>
      </div>

      {/* Image Content */}
      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
        className="md:w-1/2 relative group"
      >
        <div className="relative">
          <div className="overflow-hidden shadow-2xl">
            <img
              src="/assets/images/our-process-contact-img.png"
              alt="What We Do"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <motion.div
            animate={{ y: [0, -18, 5, 0] }}
            transition={{ repeat: Infinity, duration: 3 }}
            className="absolute top-[-20px] left-[-20px] w-[60px] h-[160px] border-t-[22px] border-l-[22px] border-teal-500"
          />
          <motion.div
            animate={{ y: [0, 18, -5, 0] }}
            transition={{ repeat: Infinity, duration: 3 }}
            className="absolute bottom-[-20px] right-[-20px] w-[60px] h-[160px] border-b-[22px] border-r-[22px] border-teal-500"
          />
        </div>
      </motion.div>
    </div>
  </div>
</div>


    </div>
  );
}
